import React from 'react';

const QuoteHero: React.FC = () => {
  return (
    <section className="relative w-full py-12 px-4 flex justify-center bg-[#fafafa]">
      <div className="relative w-full max-w-[1440px] h-[50vh] min-h-[400px] flex items-center overflow-hidden bg-zinc-950 rounded-sm shadow-2xl border border-white/5">
        {/* Subtle industrial background texture */}
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-20 mix-blend-overlay"
          style={{ backgroundImage: 'url("https://images.unsplash.com/photo-1574689232449-3e67ae143a75?q=80&w=2070&auto=format&fit=crop")' }}
        />
        <div className="absolute inset-0 bg-zinc-950/60 backdrop-blur-sm" />
        
        {/* Decorative elements */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-[#D4AF37]/5 blur-[100px] rounded-full" />

        {/* Content */}
        <div className="relative w-full px-8 md:px-16 z-10 text-center md:text-left">
          <div className="max-w-4xl mx-auto md:mx-0">
            <blockquote className="text-3xl md:text-5xl lg:text-6xl font-medium text-white mb-8 leading-[1.1] tracking-tighter drop-shadow-2xl">
              Capital doesn’t flow to potential. <br />
              It flows to <span className="bg-[linear-gradient(to_right,#D4AF37_0%,#F7E08A_20%,#FFF9E3_40%,#FFFFFF_50%,#FFF9E3_60%,#F7E08A_80%,#D4AF37_100%)] bg-clip-text text-transparent animate-gold-shimmer">clarity, credibility, and structure.</span>
            </blockquote>
            <div className="h-px w-24 bg-[#D4AF37] mb-6 hidden md:block" />
            <p className="text-zinc-400 text-[15px] font-black uppercase tracking-[0.3em]">
              That’s the gap we fix.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuoteHero;